import { doc, getDoc, setDoc, updateDoc, runTransaction } from 'firebase/firestore';
import { db } from '../firebaseConfig';

/**
 * Obtiene el siguiente número de recibo de manera segura usando transacciones
 * Formato: REC-YYYY-XXXXX donde XXXXX es el número correlativo de 5 dígitos
 */
export async function getNextReceiptNumber(): Promise<string> {
  const counterRef = doc(db, 'system', 'receiptCounter');
  
  try {
    const nextNumber = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      
      let currentYear = new Date().getFullYear();
      let currentCount = 1;
      
      if (counterDoc.exists()) {
        const data = counterDoc.data();
        const savedYear = data.year;
        
        // Si el año cambió, reiniciar el contador
        if (savedYear !== currentYear) {
          currentCount = 1;
        } else {
          currentCount = (data.count || 0) + 1;
        }
      }
      
      // Actualizar el contador en Firestore
      transaction.set(counterRef, {
        year: currentYear,
        count: currentCount,
        lastUpdated: new Date().toISOString()
      });
      
      return currentCount;
    });
    
    // Formatear el número de recibo
    const year = new Date().getFullYear();
    const paddedNumber = String(nextNumber).padStart(5, '0');
    return `REC-${year}-${paddedNumber}`;
    
  } catch (error) {
    console.error('Error al obtener número de recibo:', error);
    throw new Error('No se pudo generar el número de recibo');
  }
}

/**
 * Obtiene el contador actual sin incrementarlo
 * Útil para verificar el estado del contador
 */
export async function getCurrentReceiptCount(): Promise<{ year: number; count: number }> {
  const counterRef = doc(db, 'system', 'receiptCounter');
  
  try {
    const counterDoc = await getDoc(counterRef);
    
    if (counterDoc.exists()) {
      const data = counterDoc.data();
      return {
        year: data.year || new Date().getFullYear(),
        count: data.count || 0
      };
    }
    
    return {
      year: new Date().getFullYear(),
      count: 0
    };
  } catch (error) {
    console.error('Error al obtener contador de recibos:', error);
    throw error;
  }
}

/**
 * Inicializa el contador de recibos (solo para uso administrativo)
 * @param year Año a inicializar
 * @param count Número inicial
 */
export async function initializeReceiptCounter(year?: number, count: number = 0): Promise<void> {
  const counterRef = doc(db, 'system', 'receiptCounter');
  
  try {
    await setDoc(counterRef, {
      year: year || new Date().getFullYear(),
      count: count,
      lastUpdated: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error al inicializar contador de recibos:', error);
    throw error;
  }
}


